import { FeatureAppLoader } from '@feature-hub/react';
import { Breakpoints, CTA } from '@volkswagen-onehub/components-core';
import React, { useRef, useState } from 'react';
import { OfertasContext } from '../context/ofertas-context';
import {
	getFinanciacionType,
	getPagoFinanciado,
	getPagoUnico,
} from '../helpers/ofertas-helper';
import { Oferta } from '../services/ofertas-service/models/ofertas';
import { useTrackingManager } from '../tracking/use-tracking-manager';

export const RedirectCTAs = ({
	oferta,
	copy,
	isMobile,
	emphasis,
	trackingRef,
	formTrigger,
}: {
	oferta: Oferta;
	copy: string;
	isMobile: boolean;
	emphasis: 'primary' | 'secondary';
	formTrigger: string;
	trackingRef?: string;
}) => {
	const { featureAppService } = React.useContext(OfertasContext);
	const [showOneFormCallMe, setShowOneFormCallMe] = useState<boolean>(false);
	const [showOneForm, setShowOneForm] = useState<boolean>(false);

	const featureAppRef = useRef(null);
	//const marketingCodeConfigRef = useRef(null); //Esto tiene que ver con tracking

	const trackingManager = useTrackingManager();

	const handleOnClick = (copy: string) => {
		setShowOneForm(true);

		const pagoFinanciado = getPagoFinanciado(oferta.datosEconomicos);
		trackingManager.trackOfertasButtonClick(
			copy,
			{ contentId: trackingRef ? `${copy} - ${trackingRef}` : copy },
			{
				CarlineId: oferta.carline?.code.toString(),
				CarlineName: oferta.carline?.title,
				ModelId: oferta.configuracion.motorizacion.code?.split('-')[0],
				ModelName: oferta.carline?.salesgroup.model.name,
				ModelYear: oferta.carline?.salesgroup.year.toString(),
				SalesgroupName: oferta.carline?.salesgroup.title,
				PriceRateType: pagoFinanciado
					? getFinanciacionType(pagoFinanciado)
					: undefined,
				PriceRateTotal: pagoFinanciado?.precio ?? undefined,
				PriceRateCurrency: 'EUR',
				PriceTotalTotal:
					getPagoUnico(oferta.datosEconomicos)?.precio ?? undefined,
				PriceTotalCurrency: 'EUR',
			},
		);
	};

	const renderOneForm = (
		oferta: Oferta,
		//financeCalculation: CalculatorDefaultResponse['rawResponse'] | undefined,
	) => {
		if (showOneForm) {
			const featureApp =
				featureAppService.featureAppConfigurations[formTrigger];
			featureAppRef.current = featureApp;
		} else if (showOneFormCallMe) {
			const featureApp =
				featureAppService.featureAppConfigurations[
					'es-oneform-callme-embedded'
				];
			featureAppRef.current = featureApp;
		}

		return (
			<>
				<FeatureAppLoader
					{...featureAppRef.current}
					// src="http://localhost:3001/vw-oneform-feature-app.umd.js"
					featureAppId={`${featureAppRef.current.name}:oneform`}
					done={() => {
						setShowOneForm(false);
						setShowOneFormCallMe(false);
					}}
					beforeCreate={(env) => {
						if (env.featureServices['fa-content-service']) {
							env.featureServices['fa-content-service'].content = {
								featureApp: 'es-ofertas',
								oferta: oferta,
								//financeCalculation: financeCalculation,
							};
						}
						if (env.featureServices['api-key-provider']) {
							env.featureServices['api-key-provider'].apiKey =
								featureAppRef.current.apiKey;
						}
						if (env.featureServices.tracking) {
							env.featureServices.tracking.contextualEventData = {
								event: {
									environment: {
										featureAppId: featureAppRef.current.trackingId,
									},
								},
							};
						}
					}}
				/>
			</>
		);
	};

	const RenderOneFormCTA = (): React.ReactElement => {
		return (
			<CTA
				data-testid="redirect-cta"
				tag="button"
				emphasis={emphasis}
				size={isMobile ? 'large' : 'small'}
				stretchContent={{
					[Breakpoints.default]: true,
					[Breakpoints.b560]: false,
				}}
				onClick={() => handleOnClick(copy)}
			>
				{copy}
			</CTA>
		);
	};

	return (
		<>
			{RenderOneFormCTA()}

			{showOneForm ? renderOneForm(oferta) : null}

			{/* ELIMINADO LA INFORMACION DE LA CALULADORA FINANCIERA */}
			{/* {showOneForm
				? renderOneForm(oferta, oferta.calculatedFinance.rawResponse)
				: null} */}
		</>
	);
};
